import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';

import { StyledButtonContainer, StyledFab } from '../../styles/input-row';

interface AddRowButtonProps {
    addRow: () => void;
}

const AddRowButton: React.FC<AddRowButtonProps> = ({ addRow }) => {
    const { t } = useTranslation('generic');

    return (
        <StyledButtonContainer>
            <StyledFab color="primary" aria-label={t('add-row')} onClick={addRow}>
                <AddIcon />
            </StyledFab>
        </StyledButtonContainer>
    );
};

export default AddRowButton;
